import { ReactComponent as MusioLogo } from "@/assets/musio-logos/logo_center_top.svg";
import { Button } from "@/components/ui/button";
import { useLocation } from "wouter";

export default function ErrorPage() {
  const [_, navigate] = useLocation();

  return (
    <div className="h-full w-full flex flex-col items-center justify-center">
      <MusioLogo />
      <div className="musio-glass flex flex-col items-center justify-center space-y-5 p-8">
        <h1 className=" text-2xl font-extrabold text-musio-light-lilac">Something went wrong</h1>
        <Button onClick={() => navigate("~/")}>Return</Button>
      </div>
    </div>
  );
}
